import React, { Component } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { withRedux } from '../hoc';
import { SocialLink } from '../components';

const SocialLinkStyled = styled.ul`
  display: flex;
  flex-direction: row;
  li {
    margin: 7px;
    i {
      font-size: 20px;
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
`;

const mapStateToProps = ({ language, t, contact }) => {
  return {
    language,
    t,
    socials: _.get(contact, 'data.social_url')
  };
};

@withRedux(mapStateToProps)
export default class SocialList extends Component {
  getIcon = platform => {
    switch (platform) {
      case 'facebook':
        return <SocialLink.Facebook />;
      case 'instagram':
        return <SocialLink.Instagram />;
      case 'pinterest':
        return <SocialLink.Pinterest />;
      case 'youtube':
        return <SocialLink.Youtube />;
      default:
        return null;
    }
  };
  render() {
    const { socials } = this.props;
    return (
      <SocialLinkStyled className="social-link">
        {_.map(socials, (social, index) => {
          const platform = _.get(social, 'platform');
          return <li key={index}><a href={_.get(social, 'url')} target="_blank">{this.getIcon(platform)}</a></li>;
        })}
      </SocialLinkStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SocialList.js